<template>
    
    <router-view />

    <Dialog v-model:visible="updateAvailable" modal header="Aggiornamento Disponibile" :closable="false">
        <div class="p-3">
            <p>È disponibile una nuova versione. Aggiorna ora per vedere le modifiche!</p>
        </div>
        <template #footer>
            <Button label="Aggiorna e Ricarica" icon="pi pi-refresh" @click="refreshApp" class="p-button-rounded"/>
        </template>
    </Dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import pkg from '../package.json';

const updateAvailable = ref(false);
let registrationWaiting = null;

// Funzione per applicare l'aggiornamento quando l'utente clicca sul pulsante
const refreshApp = () => {
    updateAvailable.value = false;

    if (registrationWaiting) {
        // Obbligatorio: diciamo al nuovo SW di attivarsi ORA
        registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
    }

    // Aspettiamo un battito di ciglia (100ms) per dare tempo al SW di ricevere il messaggio
    // e poi ricarichiamo brutalmente
    setTimeout(() => {
        window.location.reload(true); 
    }, 100);
};

onMounted(async () => {
    console.log("🚀 Versione App Caricata:", pkg.version);

    // 1. Spostiamo il timer QUI, così parte appena l'app viene aperta
    if ('serviceWorker' in navigator) {
        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            
            // Se troviamo un worker, avviamo il controllo periodico
            registrations.forEach(registration => {
                // Controllo immediato se c'è già qualcosa in waiting
                if (registration.waiting) {
                    registrationWaiting = registration;
                    updateAvailable.value = true;
                }

                // Avvia il timer ogni 60 secondi
                setInterval(() => {
                    console.log('⏱️ Controllo aggiornamenti automatico (1 min)...');
                    registration.update();
                }, 60000);
            });
        } catch (err) {
            console.error("Errore nel recupero dei SW:", err);
        }
    }

    // 2. Ascoltatore per l'evento swUpdated
    document.addEventListener('swUpdated', (event) => {
        registrationWaiting = event.detail.waiting;
        updateAvailable.value = true;
    }, { once: true });
});
</script>

<style lang="scss">
// @import './App.scss';
.p-breadcrumb{
    margin-bottom: 20px;
}
</style>
